import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDropDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.83337 8.33334L10 12.5L14.1667 8.33334H5.83337Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowDropDown);
export default ForwardRef;
